import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary btn-sm mb-10",
  "data-bs-toggle": "tooltip",
  title: "Add Portal Connection",
  id: "add_portal_drawer_toggle"
}, " Add New Signer ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Edit")


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const handleClick = () => {
  console.log("click");
};

const tableData = [
  {
    date: "2016-05-03",
    name: "Tom",
    state: "California",
    city: "Los Angeles",
    address: "No. 189, Grove St, Los Angeles",
    zip: "CA 90036",
    tag: "Home",
  },
  {
    date: "2016-05-02",
    name: "Tom",
    state: "California",
    city: "Los Angeles",
    address: "No. 189, Grove St, Los Angeles",
    zip: "CA 90036",
    tag: "Office",
  },
  {
    date: "2016-05-04",
    name: "Tom",
    state: "California",
    city: "Los Angeles",
    address: "No. 189, Grove St, Los Angeles",
    zip: "CA 90036",
    tag: "Home",
  },
  {
    date: "2016-05-01",
    name: "Tom",
    state: "California",
    city: "Los Angeles",
    address: "No. 189, Grove St, Los Angeles",
    zip: "CA 90036",
    tag: "Office",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: tableData,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "date",
          label: "Date",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "state",
          label: "State",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "city",
          label: "City",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "address",
          label: "Address",
          width: "600"
        }),
        _createVNode(_component_el_table_column, {
          prop: "zip",
          label: "Zip",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Operations",
          width: "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})